import { SelectedWeatherItem } from './types';
import { ProductCategory } from '../products/categories';

export default function weatherSortFunction(a: SelectedWeatherItem, b: SelectedWeatherItem): number {
    const indexA = getSortIndex(a.product.category, a.id);
    const indexB = getSortIndex(b.product.category, b.id);

    return indexB - indexA;
}

const getSortIndex = (category: number, id: number): number => {
    switch (category) {
        case ProductCategory.none:
            return 0;
        case ProductCategory.lightning:
            return 1;
        case ProductCategory.airport:
            return 2;
        case ProductCategory.airspace:
            return 3;
        case ProductCategory.winds:
            return 4;
            break;
        case ProductCategory.fronts:
            return 5;
        case ProductCategory.airmetsSigmets:
            return 6;
        case ProductCategory.convective:
            return 7;
        case ProductCategory.miscellaneous:
            return 8;
        case ProductCategory.turbulence:
            return 9;
        case ProductCategory.icing:
            return 10;
        case ProductCategory.sigWx:
            return 11;
        case ProductCategory.radar:
            if (isRadarTopProd(id)) {
                return 12;
            }
            return 13;
        case ProductCategory.satellite:
            return 14;
        case ProductCategory.flex:
            return 15;
        case ProductCategory.database:
            return 16;
        default:
            return -1; // shouldn't happen
    }
};

function isRadarTopProd(id: number): boolean {
    return id === 0x1023 || id === 0x1092 || id === 0x1003 || id === 0x101f || id === 0x1043 || id === 0x0082;
}
